import React, { createContext, useContext, useState } from 'react';

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const showLoader = (msg = '') => {
        setMessage(msg);
        setLoading(true);
    };

    const hideLoader = () => {
        setLoading(false);
        setMessage('');
    };

    return (
        <LoaderContext.Provider value={{ loading, message, showLoader, hideLoader }}>
            {children}
        </LoaderContext.Provider>
    );
};